import { useEffect } from 'react';
import { useUser } from '@descope/react-sdk';
import { usePostHog } from 'posthog-js/react';
import { useUserClientContext } from '@/app/clientContext';
import { getAppConfig } from '@/app/config';

const OVERSTORY_GROUP = { key: 'OVERSTORY', name: 'Overstory' };

export const AnalyticsIdentity = () => {
  const posthog = usePostHog();
  const { user } = useUser();
  const { context, isInternalUser, isUserLoaded } = useUserClientContext();

  useEffect(() => {
    if (!user?.userId) return;
    return () => {
      posthog.stopSessionRecording();
      posthog.reset();
    };
  }, [posthog, user?.userId]);

  useEffect(() => {
    if (!user?.userId || !isUserLoaded) return;
    if (!getAppConfig().posthog?.recordSessions) return;
    posthog.startSessionRecording();
  }, [posthog, user?.userId, isUserLoaded]);

  useEffect(() => {
    if (!user?.userId || !isUserLoaded) return;
    posthog.identify(user.userId, { internal: isInternalUser });
  }, [posthog, user?.userId, isUserLoaded, isInternalUser]);

  useEffect(() => {
    if (!isUserLoaded || !context.code) return;
    const group = isInternalUser
      ? OVERSTORY_GROUP
      : { key: context.code, name: context.name };
    posthog.group('client', group.key, { name: group.name });
    posthog.register({ viewed_client: context.code });
  }, [posthog, isUserLoaded, isInternalUser, context.code, context.name]);

  return null;
};
